import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetVaccineTemplateDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/VaccineTemplate/GetDetail?` + params, null);

export const GetVaccineTemplateList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/VaccineTemplate/GetList?` + params, null);

export const CreateVaccineTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/VaccineTemplate/Create`, data);

export const UpdateVaccineTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/VaccineTemplate/Update`, data);    

export const DeleteVaccineTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/VaccineTemplate/Delete`, data);

export const UpdateDefaultNotificationTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/VaccineTemplate/UpdateDefault`, data);

